import { z } from 'zod';

const envSchema = z.object({
  VITE_SUPABASE_URL: z.url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_BACKEND_URL: z.url(),
  VITE_SENTRY_DSN: z.url().optional(),
  VITE_SENTRY_DEBUG: z
    .string()
    .transform((val) => val === 'true')
    .optional(),
  VITE_TURNSTILE_SITE_KEY: z.string().min(1),
  MODE: z
    .enum(['development', 'production', 'test', 'localdev'])
    .transform((val) => (val === 'localdev' ? 'development' : val))
    .default('development'),
});

const rawEnv = {
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  VITE_BACKEND_URL: import.meta.env.VITE_BACKEND_URL,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_DEBUG: import.meta.env.VITE_SENTRY_DEBUG,
  VITE_TURNSTILE_SITE_KEY: import.meta.env.VITE_TURNSTILE_SITE_KEY,
  MODE: import.meta.env.MODE,
};

const parsed = envSchema.safeParse(rawEnv);

if (!parsed.success) {
  const formatted = parsed.error.issues
    .map((e) => `${e.path.join('.')}: ${e.message}`)
    .join('\n');
  throw new Error(`❌ Invalid environment variables (frontend):\n${formatted}`);
}

export const env = parsed.data;
